import { GET_CUSTOMER_SEARCH } from '../constants';
import { cookieFactory } from '../../utils';

const { setCookie, getCookie } = cookieFactory();
export default (state = { customerInfo: [] }, action) => {
  switch (action.type) {
    case `${GET_CUSTOMER_SEARCH}_PENDING`:
      return state;
    case `${GET_CUSTOMER_SEARCH}_FULFILLED`: {
      const data = action.payload;
      if (data.error) return state;
      const now = new Date().getTime();
      const tomorrow = new Date(new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0)).getTime();
      const CUSTOMER_INFO = JSON.parse(getCookie('CUSTOMER_INFO'));
      if (data.firstName && data.email) {
        const name = `${data.firstName ? data.firstName : ''} ${data.lastName ? data.lastName : ''}`;
        const value = CUSTOMER_INFO
          ? [{ name, email: data.email }, ...CUSTOMER_INFO.filter(customer => customer.email !== data.email)]
          : [{ name, email: data.email }];
        if (value.length >= 17) {
          value.pop(value.length - 1);
          setCookie('CUSTOMER_INFO', JSON.stringify(value), tomorrow - now);
        } else {
          setCookie('CUSTOMER_INFO', JSON.stringify(value), tomorrow - now);
        }
      }
      return { ...state, customerInfo: { ...data, name: `${data.lastName} ${data.firstName}` } };
    }
    case `${GET_CUSTOMER_SEARCH}_REJECTED`: {
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/customerSearch.js